import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Folder, Subfolder } from '../models/models';
import { environment } from '../../../../environments/environment';
import { Params } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class FolderService {
  constructor(private http: HttpClient) {}

  getFolderFrom(params: Params | null, pageNumber: number): Observable<Folder> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('pageNumber', pageNumber.toString());
    httpParams = httpParams.append('pageSize', '20');
    if (params && params['folder']) {
      return this.http.get<Folder>(`${environment.apiUrl}/companyFolders/${params['folder']}`, {
        params: httpParams
      });
    } else {
      const companyIds = params && params['companyId'] ? params['companyId'] : [];
      const numbersArray = Array.isArray(companyIds) ? companyIds : [companyIds];
      numbersArray.forEach(customer => (httpParams = httpParams.append('companyIds', customer)));
      return this.http.get<Folder>(`${environment.apiUrl}/companyFolders/root`, { params: httpParams });
    }
  }

  create(body: { name: string | null; companyId: string | null; parentFolderId: string | null }) {
    return this.http.post<Subfolder>(`${environment.apiUrl}/companyFolders`, body);
  }

  delete(id: number) {
    return this.http.delete(`${environment.apiUrl}/companyFolders/${id}`);
  }

  edit(id: number, body: { name: string }) {
    return this.http.put<Subfolder>(`${environment.apiUrl}/companyFolders/${id}`, body);
  }
}
